function updateCompanyNewsAttachments(resource, params, dataProvider) {
  return dataProvider.update(resource, params);
}

function createCompanyNewsAttachments(resource, params, dataProvider) {
  return dataProvider.create(resource, params);
}

export {createCompanyNewsAttachments, updateCompanyNewsAttachments};
